module.exports = {
          srcSet: __webpack_public_path__ + "cd9bdd57beb49da300bd8c477ff8a6d2-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "cd9bdd57beb49da300bd8c477ff8a6d2-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "cd9bdd57beb49da300bd8c477ff8a6d2-66.jpg",
          toString:function(){return __webpack_public_path__ + "cd9bdd57beb49da300bd8c477ff8a6d2-66.jpg"},
          
          width: 66,
          height: 66
        }